import React from 'react';

const Shimmer = ({ className = '' }) => (
    <div className={`patient-files-skeleton-block ${className}`.trim()} aria-hidden="true" />
);

export function PatientOverviewSkeleton() {
    return (
        <div className="patient-detail-tab-panel patient-files-skeleton-panel" aria-hidden="true">
            <div className="patient-files-skeleton-panel__header">
                <div className="patient-files-skeleton-panel__heading">
                    <Shimmer className="patient-files-skeleton-block--title" />
                    <Shimmer className="patient-files-skeleton-block--subtitle" />
                </div>
                <Shimmer className="patient-files-skeleton-block--button" />
            </div>

            {Array.from({ length: 3 }).map((_, rowIndex) => (
                <div key={`overview-row-${rowIndex}`} className="patient-files-skeleton-field-grid">
                    {Array.from({ length: 3 }).map((__, colIndex) => (
                        <div key={`overview-field-${rowIndex}-${colIndex}`} className="patient-files-skeleton-field">
                            <Shimmer className="patient-files-skeleton-block--label" />
                            <Shimmer className="patient-files-skeleton-block--input" />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export function PatientAppointmentsSkeleton({ count = 5 }) {
    return (
        <div className="patient-detail-tab-panel patient-files-skeleton-panel" aria-hidden="true">
            <div className="patient-files-skeleton-panel__header">
                <div className="patient-files-skeleton-panel__heading">
                    <Shimmer className="patient-files-skeleton-block--title" />
                    <Shimmer className="patient-files-skeleton-block--subtitle" />
                </div>
            </div>

            <div className="patient-detail-table-wrap patient-files-skeleton-table-wrap">
                <div className="patient-files-skeleton-table-head patient-files-skeleton-table-head--appointments">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <Shimmer key={`appt-head-${index}`} className="patient-files-skeleton-block--th" />
                    ))}
                </div>
                {Array.from({ length: count }).map((_, rowIndex) => (
                    <div
                        key={`appt-row-${rowIndex}`}
                        className="patient-files-skeleton-table-row patient-files-skeleton-table-row--appointments"
                    >
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-long" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-medium" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-medium" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-short" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-badge" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-short" />
                    </div>
                ))}
            </div>
        </div>
    );
}

export function PatientCommPrefsSkeleton() {
    return (
        <div className="patient-detail-tab-panel patient-pref-panel patient-files-skeleton-panel" aria-hidden="true">
            <div className="patient-files-skeleton-panel__header">
                <div className="patient-files-skeleton-panel__heading">
                    <Shimmer className="patient-files-skeleton-block--title" />
                    <Shimmer className="patient-files-skeleton-block--subtitle" />
                </div>
                <Shimmer className="patient-files-skeleton-block--button" />
            </div>

            <div className="patient-pref-layout">
                <div className="patient-pref-section">
                    <div className="patient-pref-section__header">
                        <Shimmer className="patient-files-skeleton-block--section-icon" />
                        <Shimmer className="patient-files-skeleton-block--section-title" />
                    </div>
                    <div className="patient-pref-section__body">
                        <div className="patient-pref-channel-grid">
                            {Array.from({ length: 3 }).map((_, index) => (
                                <div key={`channel-${index}`} className="patient-files-skeleton-channel-card">
                                    <div className="patient-files-skeleton-channel-card__top">
                                        <Shimmer className="patient-files-skeleton-block--avatar" />
                                        <div className="patient-files-skeleton-channel-card__text">
                                            <Shimmer className="patient-files-skeleton-block--line-medium" />
                                            <Shimmer className="patient-files-skeleton-block--line-short" />
                                        </div>
                                        <Shimmer className="patient-files-skeleton-block--pill" />
                                    </div>
                                    <Shimmer className="patient-files-skeleton-block--input" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="patient-pref-section">
                    <div className="patient-pref-section__header">
                        <Shimmer className="patient-files-skeleton-block--section-icon" />
                        <Shimmer className="patient-files-skeleton-block--section-title" />
                    </div>
                    <div className="patient-pref-section__body">
                        <div className="patient-pref-notification-grid">
                            {Array.from({ length: 9 }).map((_, index) => (
                                <div key={`notification-${index}`} className="patient-files-skeleton-notification-card">
                                    <div className="patient-files-skeleton-notification-card__main">
                                        <Shimmer className="patient-files-skeleton-block--icon" />
                                        <Shimmer className="patient-files-skeleton-block--line-medium" />
                                    </div>
                                    <Shimmer className="patient-files-skeleton-block--pill" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function PatientActivitySkeleton({ count = 4, compact = false }) {
    const list = (
        <div className="patient-files-skeleton-activity-list">
            {Array.from({ length: count }).map((_, index) => (
                <div key={`activity-${index}`} className="patient-files-skeleton-activity-item">
                    <Shimmer className="patient-files-skeleton-block--avatar" />
                    <div className="patient-files-skeleton-activity-item__content">
                        <div className="patient-files-skeleton-activity-item__top">
                            <Shimmer className="patient-files-skeleton-block--line-medium" />
                            <Shimmer className="patient-files-skeleton-block--pill" />
                        </div>
                        <Shimmer className="patient-files-skeleton-block--line-long" />
                        <Shimmer className="patient-files-skeleton-block--line-short" />
                    </div>
                </div>
            ))}
        </div>
    );

    if (compact) {
        return list;
    }

    return (
        <div className="patient-detail-tab-panel patient-files-skeleton-panel" aria-hidden="true">
            <div className="patient-files-skeleton-panel__header">
                <div className="patient-files-skeleton-panel__heading">
                    <Shimmer className="patient-files-skeleton-block--title" />
                    <Shimmer className="patient-files-skeleton-block--subtitle" />
                </div>
            </div>
            {list}
        </div>
    );
}

export function PatientInvalidDetailsSkeleton({ count = 4 }) {
    return (
        <div className="patient-detail-tab-panel patient-files-skeleton-panel" aria-hidden="true">
            <div className="patient-files-skeleton-panel__header">
                <div className="patient-files-skeleton-panel__heading">
                    <Shimmer className="patient-files-skeleton-block--title" />
                    <Shimmer className="patient-files-skeleton-block--subtitle" />
                </div>
                <div className="d-flex gap-2">
                    <Shimmer className="patient-files-skeleton-block--button" />
                    <Shimmer className="patient-files-skeleton-block--button" />
                </div>
            </div>

            <div className="patient-detail-table-wrap patient-files-skeleton-table-wrap">
                <div className="patient-files-skeleton-table-head patient-files-skeleton-table-head--invalid">
                    <Shimmer className="patient-files-skeleton-block--checkbox" />
                    {Array.from({ length: 4 }).map((_, index) => (
                        <Shimmer key={`invalid-head-${index}`} className="patient-files-skeleton-block--th" />
                    ))}
                    <Shimmer className="patient-files-skeleton-block--th patient-files-skeleton-block--th-action" />
                </div>
                {Array.from({ length: count }).map((_, rowIndex) => (
                    <div
                        key={`invalid-row-${rowIndex}`}
                        className="patient-files-skeleton-table-row patient-files-skeleton-table-row--invalid"
                    >
                        <Shimmer className="patient-files-skeleton-block--checkbox" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-badge" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-long" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-short" />
                        <Shimmer className="patient-files-skeleton-block--cell patient-files-skeleton-block--cell-action" />
                    </div>
                ))}
            </div>
        </div>
    );
}
